<section class="courses-area ptb-100 bg-fafafb">
  <div class="container">
    @for (sectionTitleContent of sectionTitle; track sectionTitleContent) {
      <div class="section-title">
        <h2>{{sectionTitleContent.title}}</h2>
        <p>{{sectionTitleContent.paragraphText}}</p>
      </div>
    }

    <div class="row">
      @for (coursesContent of singleCoursesBox; track coursesContent) {
        <div class="col-lg-4 col-md-6">
          <div class="single-courses-box">
            <div class="courses-image">
              <a routerLink="/{{coursesContent.link}}" class="d-block image">
                <img [src]="coursesContent.courseImg" [alt]="coursesContent.title + ' course'">
              </a>
              <div class="price shadow {{coursesContent.coursePriceClass}}">{{coursesContent.coursePrice}}</div>
            </div>
            <div class="courses-content">
              <div class="course-author d-flex align-items-center">
                <img [src]="coursesContent.authorImg" class="rounded-circle" [alt]="coursesContent.authorName">
                <span>{{coursesContent.authorName}}</span>
              </div>
              <h3><a routerLink="/{{coursesContent.link}}">{{coursesContent.title}}</a></h3>
              <p>{{coursesContent.paragraphText}}</p>
              <ul class="courses-box-footer d-flex justify-content-between align-items-center">
                <li>
                  <i class='flaticon-agendas'></i> {{coursesContent.courseDuration}}
                </li>
                <li>
                  <i class='flaticon-team'></i> {{coursesContent.studentApply}}
                </li>
              </ul>
            </div>
          </div>
        </div>
      }

      <div class="col-lg-12 col-md-12">
        @for (Info of coursesInfo; track Info) {
          <div class="courses-info">
            <p>{{Info.paragraphText}} <a routerLink="/{{Info.link}}">{{Info.linkText}}</a></p>
          </div>
        }
      </div>
    </div>
  </div>

  <div class="vector-shape6"><img src="assets/img/shape/vector-shape6.png" alt="image"></div>
</section>